<h3 mat-dialog-title class="historico-atualizacao-title">
  Acompanhamento de atualizações
</h3>
<div mat-dialog-content class="historico-atualizacao-dialog">
  <mat-accordion
    *ngIf="
      (historicoAtualizacoes$ | async) &&
      (historicoAtualizacoes$ | async).length > 0
    "
  >
    <mat-expansion-panel [expanded]="true" class="expansion-atualizacao-dialog">
      <mat-expansion-panel-header class="historico-atualizacao-header">
        <mat-panel-title>Últimas atualizações não lidas</mat-panel-title>
        <mat-panel-description> </mat-panel-description>
      </mat-expansion-panel-header>

      <mat-list *ngIf="(historicoAtualizacoes$ | async).length > 0">
        <mat-list-item
          class="historico-atualizacao-list-item"
          *ngFor="let item of historicoAtualizacoes$ | async"
        >
          <div mat-line>
            {{ item.dataAtualizacao | date : "dd/MM/yyyy" }} -
            {{ item.descricao | removeHtmlTags }}
          </div>
          <button
            class="historico-atualizacao-button-new"
            mat-icon-button
            (click)="abrirEmNovaGuia(item.tituloLei, item.idLei, item.idItem)"
          >
            <mat-icon
              mat-list-icon
              matTooltip=""
              class="material-icons-outlined"
            >
              open_in_new
            </mat-icon>
          </button>
        </mat-list-item>
      </mat-list>
    </mat-expansion-panel>
  </mat-accordion>

  <mat-accordion>
    <mat-expansion-panel class="expansion-atualizacao-dialog">
      <mat-expansion-panel-header class="historico-atualizacao-header">
        <mat-panel-title>Histórico de leis</mat-panel-title>
        <mat-panel-description> </mat-panel-description>
      </mat-expansion-panel-header>

      <mat-list *ngIf="(historicoAtualizacoesLeis$ | async).length > 0">
        <mat-list-item
          *ngFor="let itemLeis of historicoAtualizacoesLeis$ | async"
        >
          <div mat-line>
            {{ itemLeis.dataAtualizacao | date : "dd/MM/yyyy" }} -
            {{ itemLeis.descricao | removeHtmlTags }}
          </div>
          <button
            class="historico-atualizacao-button-new"
            mat-icon-button
            (click)="
              abrirEmNovaGuia(
                itemLeis.tituloLei,
                itemLeis.idLei,
                itemLeis.idItem
              )
            "
          >
            <mat-icon
              mat-list-icon
              matTooltip=""
              class="material-icons-outlined"
            >
              open_in_new
            </mat-icon>
          </button>
        </mat-list-item>
      </mat-list>
    </mat-expansion-panel>
  </mat-accordion>

  <mat-accordion>
    <mat-expansion-panel class="expansion-atualizacao-dialog">
      <mat-expansion-panel-header class="historico-atualizacao-header">
        <mat-panel-title>Histórico de referência</mat-panel-title>
        <mat-panel-description> </mat-panel-description>
      </mat-expansion-panel-header>

      <mat-list *ngIf="(historicoAtualizacoesReferencia$ | async).length > 0">
        <mat-list-item
          *ngFor="
            let itemReferencia of historicoAtualizacoesReferencia$ | async
          "
        >
          <div mat-line>
            {{ itemReferencia.dataAtualizacao | date : "dd/MM/yyyy" }} -
            {{ itemReferencia.descricao | removeHtmlTags }}
          </div>
          <button
            class="historico-atualizacao-button-new"
            mat-icon-button
            (click)="
              abrirEmNovaGuia(
                itemReferencia.tituloLei,
                itemReferencia.idLei,
                itemReferencia.idItem
              )
            "
          >
            <mat-icon
              mat-list-icon
              matTooltip=""
              class="material-icons-outlined"
            >
              open_in_new
            </mat-icon>
          </button>
        </mat-list-item>
      </mat-list>
    </mat-expansion-panel>
  </mat-accordion>

  <mat-accordion>
    <mat-expansion-panel class="expansion-atualizacao-dialog">
      <mat-expansion-panel-header class="historico-atualizacao-header">
        <mat-panel-title>Histórico de comentários</mat-panel-title>
        <mat-panel-description> </mat-panel-description>
      </mat-expansion-panel-header>

      <mat-list *ngIf="(historicoAtualizacoesComentarios$ | async).length > 0">
        <mat-list-item
          *ngFor="
            let itemComentarios of historicoAtualizacoesComentarios$ | async
          "
        >
          <div mat-line>
            {{ itemComentarios.dataAtualizacao | date : "dd/MM/yyyy" }} -
            {{ itemComentarios.descricao | removeHtmlTags }}
          </div>
          <button
            class="historico-atualizacao-button-new"
            mat-icon-button
            (click)="
              abrirEmNovaGuia(
                itemComentarios.tituloLei,
                itemComentarios.idLei,
                itemComentarios.idItem
              )
            "
          >
            <mat-icon
              mat-list-icon
              matTooltip=""
              class="material-icons-outlined"
            >
              open_in_new
            </mat-icon>
          </button>
        </mat-list-item>
      </mat-list>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<div mat-dialog-actions class="historico-atualizacao-dialog-actions">
  <button
    mat-button
    mat-raised-button
    color="warn"
    (click)="confirmarCloseHistorico()"
  >
    Fechar
  </button>
</div>
